module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAA0CAYAAACZ8ljPAAABI0lEQVRYR93YOwrCQBAG4NnkGh4nIKayECw8gxeytxAsLCQYiafRa2wiGyQY89jXP1M41Xbfzkwz/KooH6u60QciokQl+3yZXcybq9T1dn82RIsPoFOV7PJldpICjcOKqqKs1rqpz0SUfnXFhiqDFGW11U19lEBbUBLtQCm0B0qgA5AbHQU50UmQC50FOVAriEadQCTqDKJQLxCBeoOxaBAYgwaDoWgUGIJGg74oBPRBYaArCgVdUDhoQTcs4BSqiF7/Ac6cnfiR2m5c6EhtmNktDHTBYKArBgF9sGjQF4sCQ7BgMBQLAmMwbzAW8wIRmDOIwpxAJGYF0dgsyIFNglzYKMiJDUBurAdKYB0ohbWgeLj3k5eaT7AliW2H4gGtdAT9Bi0Qw0x4We2tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-right@2x.png
// module id = 829
// module chunks = 121